<ng-container *ngIf="customer$ | async as customer">
  <input
    formcontrolname="customer"
    type="text"
    disabled="true"
    placeholder="{{ customer?.name }}"
  />
</ng-container>
<button
  *ngIf="!(userIdService.isEmulated() | async) || isEndSessionButtonVisible()"
  (click)="logoutCustomer()"
  class="eb-customer-emulation__logout-button"
>
  {{ 'asm.endSession' | cxTranslate }}
</button>
